module.exports = __webpack_public_path__ + "img/coral-org-v2.863c6f1b.jpg";